import { HYDRATE } from 'next-redux-wrapper';

import { THydrateAction } from '~/src/store';

import {
    CLEAR_DATA_TO_FEEDBACK_REQUEST,
    SEND_FEEDBACK_WITH_PHONE_RESULT,
    SET_FEEDBACK_RESULT,
} from '../actionTypes/feedback';

const initialState = {
    agreementNumber: '',
    phone: '',
    name: '',
    address: '',
    email: '',
    cause: '',
    text: '',
    files: [],
    result: {},
};

export type TActions = {
    type:
        typeof SEND_FEEDBACK_WITH_PHONE_RESULT |
        typeof CLEAR_DATA_TO_FEEDBACK_REQUEST |
        typeof SET_FEEDBACK_RESULT,
    payload: Partial<typeof initialState>,
};

type State = {
    [key: string]: any,
};

export default (state = initialState, action: TActions | THydrateAction):State => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.feedback };
        case SEND_FEEDBACK_WITH_PHONE_RESULT:
        case CLEAR_DATA_TO_FEEDBACK_REQUEST:
        case SET_FEEDBACK_RESULT: {
            return {
                ...state,
                ...action.payload,
            };
        }

        default: return state;
    }
};
